import { useState } from "react";
import { isIOS } from "react-device-detect";
import { Button } from "@/components/ui/button";
import { RotateCw } from "lucide-react";
import { getIOSVersion } from "@/lib/utils";

// problematic iOS versions for landscape display of portrait video
// tested: iOS 18.5

export default function AutoRotateVideo({
  src,
  isExistingVideo,
  setNeedsRotation,
  ...props
}: {
  isExistingVideo: boolean;
  setNeedsRotation: (b: boolean) => void;
} & React.VideoHTMLAttributes<HTMLVideoElement>) {
  const iosVersion = getIOSVersion();
  const defaultRotation =
    iosVersion?.major === 18 && iosVersion?.minor === 5 && !isExistingVideo
      ? -90
      : 0;
  const [rotation, setRotation] = useState<number>(defaultRotation);

  if (defaultRotation !== 0) {
    setNeedsRotation(true);
  }

  const rotateCW = () => {
    if (rotation === 0) {
      setRotation(-90);
      setNeedsRotation(true);
    } else {
      setRotation(0);
      setNeedsRotation(false);
    }
  };

  return (
    <div className="relative w-full pt-[100%] mb-4 overflow-hidden rounded-lg">
      <div
        className="absolute top-0 left-0 w-full h-full transition-transform duration-300"
        style={{
          transform: `rotate(${rotation}deg)`,
          transformOrigin: "center",
        }}
      >
        <video
          src={src}
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover scale-x-[-1]"
          {...props}
        />
      </div>
      {isIOS && (
        <div className="absolute top-2 right-2">
          <Button
            variant="ghost"
            size="icon"
            onClick={rotateCW}
            className="hover:bg-transparent active:bg-transparent focus-visible:ring-0"
          >
            <RotateCw className="w-4 h-4" />
          </Button>
        </div>
      )}
    </div>
  );
}
